if (!window.__amDropdownInitialized) {
  window.__amDropdownInitialized = true;

  document.addEventListener('toggle', (event) => {
    const toggledDetails = event.target;
    if (!(toggledDetails instanceof HTMLDetailsElement)) return;
    if (!toggledDetails.hasAttribute('data-am-dropdown')) return;
    if (!toggledDetails.open) return;

    document.querySelectorAll('details[data-am-dropdown][open]').forEach((details) => {
      if (details !== toggledDetails) details.removeAttribute('open');
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('details[data-am-dropdown][open]').forEach((details) => {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('details[data-am-dropdown][open]').forEach((details) => {
      details.removeAttribute('open');
    });
  });
}
